import React from 'react';
import '../../styles/admin/AdminDashboard.css';

const StatusBadge = ({ status }) => {
  const getStatusClass = (status) => {
    switch (status) {
      case 'En attente':
        return 'status-pending';
      case 'Contacté':
        return 'status-contacted';
      case 'Soumission envoyée':
        return 'status-quoted';
      case 'Complété':
        return 'status-completed';
      default:
        return 'status-pending';
    }
  };

  return (
    <span className={`status-badge ${getStatusClass(status)}`}>
      {status || 'En attente'}
    </span>
  );
};

export default StatusBadge;
